import {ReactNode} from "react";
import {Dropdown, Menu, Segment} from "semantic-ui-react";
import {normalizeString} from "../ps-models";
import {Route} from "react-router-dom";
import {useScenarioSelect} from "./scenarios/scnearioSelect";
import { Section, SectionItem } from "./builder/SectionItem";
import { NavBar } from "../ui/NavBar";

export class SectionService {
  private sections: Record<string, Section> = {};

  constructor(public basePath: string, private companyId: string) {}

  
  setHomeSection(key: string) {
    //Unset home
    Object.values(this.sections).forEach(section => {
      section.isHome = false;
    });
    this.sections[key].isHome = true;

  }
  
  addSection(data: Partial<Section>) {
    const {basePath: BASE_PATH, companyId} = this;

    if (!data.title) throw new Error("Section must have a title");
    if (!data.render) throw new Error("Section must have a render function");

    let title = data.title;
    let key = data.key || normalizeString(data.title.replace(" ", "-"));
    //replace symbols in key
    key = key.replace(/[^a-zA-Z0-9-]/g, "");
    let path = `${BASE_PATH}/${key}`;

    this.sections[key] = {
      title,
      path,
      ...data,
      key,
      render: data.render,
      order: data.order || Object.values(this.sections).length,
      getPath: () => path.replace(":companyId", companyId)
    } as Section;

  }

  getSections() {
    let sections =  Object.values(this.sections);
    return sections.sort((a, b) => {
      return a.order - b.order;
    });

  }

}

export function SectionsContent({sectionService}:{sectionService: SectionService}) {

  let homeSection = sectionService.getSections().find(section => section.isHome);

  return  <Segment>
    {homeSection && <Route exact  path={sectionService.basePath}  key={homeSection.key} render={()=> homeSection.render([],[])} />}
    {sectionService.getSections().map(section =>
      <Route exact  path={section.path}  key={section.key}
             render={()=> section.render([],[])} />
    )}

  </Segment>
}

export function SectionsContentWithScenarios({sectionService}:{sectionService: SectionService}) {

  let {component, selectedStores, compareWithStores} = useScenarioSelect();

  return  <Segment>
    {component}
    {sectionService.getSections().map(section =>
      <Route exact  path={section.path}  key={section.key}
             render={()=> section.render(selectedStores, compareWithStores)} />
    )}
  </Segment>
}

export function SectionsMenu({sectionService}:{sectionService: SectionService}) {
  //Get parent titles
  let parentsToRender = new Set(sectionService.getSections()
    .map(section => section.parent));

  let items: {parent?: string, elements: ReactNode | ReactNode[]}[] = [];

  sectionService.getSections().forEach(section => {
    if (!section.parent) {
      items.push({elements: <SectionItem key={section.key} section={section} as={Menu.Item}/>});
    } else {
      if (!parentsToRender.has(section.parent)) return;
      items.push({parent: section.parent, 
        elements : sectionService.getSections().filter(s => s.parent === section.parent)
          .map(s => <SectionItem key={s.key} section={s} as={Dropdown.Item}/>)});
    }
    parentsToRender.delete(section.parent);
  });

  return <NavBar items={items} variant="minimal" />
}